import React, { useState } from "react";
import { FaTrash } from "react-icons/fa";
import { useDispatch } from "react-redux";
import DeleteConfirmBox from "./DeleteConfirmBox";

const DeleteButton = ({ data, toDispatch, type }) => {
  const dispatch = useDispatch();

  const [showBox, setShowBox] = useState(false);

  const handleDelete = () => {
    setShowBox(true);
  };

  const handleBackDrop = () => {
    setShowBox(false);
  };

  const handleCancel = () => {
    setShowBox(false);
  };

  const handleConfirm = () => {
    setShowBox(false);
    dispatch(toDispatch(data));
  };

  return (
    <div>
      <FaTrash onClick={handleDelete} className="text-red-500 cursor-pointer" />
      {showBox && (
        <DeleteConfirmBox
          onBackDrop={handleBackDrop}
          onConfirm={handleConfirm}
          onCancel={handleCancel}
          message={type}
        />
      )}
    </div>
  );
};

export default DeleteButton;
